import { useEffect, useState } from 'react'

const TICK_INTERVAL_MS = 60_000

/**
 * Returns a numeric tick that increments every minute, and immediately when
 * the window/tab regains focus. Used to drive a re-render so wall-clock-
 * dependent state (the "NOW" PTU highlight, past-PTU detection) stays
 * accurate without requiring the user to manually refresh.
 *
 * Returning a counter (not a `DateTime`) lets consumers depend on it in
 * `useMemo` / `useEffect` deps without timezone churn — the counter changes
 * predictably; the consumer reads `DateTime.now()` inside the memo when it
 * actually needs the timestamp.
 */
export function useTickEveryMinute(): number {
  const [tick, setTick] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => setTick((prev) => prev + 1), TICK_INTERVAL_MS)
    const handleFocus = () => setTick((prev) => prev + 1)

    window.addEventListener('focus', handleFocus)

    return () => {
      clearInterval(interval)
      window.removeEventListener('focus', handleFocus)
    }
  }, [])

  return tick
}
